import { memo } from "react";

import { IconPause, IconPlay } from "@/components/icons/player.icons";

const PlayButton = memo(({ togglePlay, isPlaying }: { togglePlay: () => void; isPlaying: boolean }) => {
  return (
    <div onClick={togglePlay}>
      {isPlaying ? <IconPause className="player-icon" /> : <IconPlay className="player-icon" />}
    </div>
  );
});
PlayButton.displayName = "PlayButton";

export default PlayButton;
